import dataApplicationsContext from "../../context/dataApplicationsContext"
import { useContext, useEffect, useState } from 'react';
import UserOnglet from "../user/UserOnglet";
import UserGoBack from "../user/UserGoBack";
import { useNavigate } from "react-router-dom";
import TopicsContainer from "./TopicsContainer";

const HelpAllTopics = () => {
  const { setOngletPaiementActif, windowWidth, homeOngletActif, setHomeOngletActif } = useContext(dataApplicationsContext);
  
  useEffect(() => {   // permet d'initialiser l'onglet actif paiement a null pour cette section
    setOngletPaiementActif(null)
  }, [])

  const isSmallDevise = windowWidth < 900;
  // const [hasVote, setHasVote] = useState(false);

  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
  ]

  return (
    <div className="user-setting-container help">
      <UserGoBack
        goBackLinks={goBackLinks} isSmallDevise={isSmallDevise} guideInfo='Marche à suivre' titleClass='mb-4'
      />
      <p className="fw-500 fz-18 op-7 mb-0">Parcourez notre bibliothèque complète de rubriques d'aide.</p>
      <div className="help-content-container">
        <UserOnglet
          onglets={[{label: 'Athlète', id: 1}, {label: 'Organisateur', id: 2}]} ongletActif={homeOngletActif} setOngletActif={setHomeOngletActif}
        />
        {homeOngletActif.id === 1 && 
          <>
            <div className="help-card-grid-container allTopics mt-48">
              <TopicsContainer 
                title="Rechercher et s'inscrire" links={[
                  { label: 'Rechercher des conseils', url: '/topics/rechercher/recherche-conseils'}, 
                  { label: "S'inscrire des compétitions", url: '/topics/rechercher/sincrire-competition-index'}, 
              ]}/>
              <TopicsContainer 
                title="Vos inscriptions" links={[
                  { label: 'Mes inscriptions', url: '/topics/inscription/38'}, 
                  { label: 'Règlement file d\'attente', url: '/topics/inscription/64'}, 
                  { label: 'Modifications', url: '/topics/inscription/modification'}, 
                  { label: 'Annulations', url: '/topics/inscription/annulations'}, 
              ]}/>
              <TopicsContainer 
                title="Paiements, tarification et remboursements" links={[
                  { label: 'Payer une inscription', url: '/topics/paiement/payer-inscription'}, 
                  { label: 'Remboursements', url: '/topics/paiement/remboursements'}, 
                  { label: 'Tarification et frais', url: '/topics/paiement/tarification'}, 
                  { label: 'Factures et reçus', url: '/topics/paiement/factures'},
              ]}/>
              <TopicsContainer 
                title='Votre compte' links={[
                  { label: 'Créer un compte', url: '/topics/compte/1'}, 
                  { label: 'Gérer votre compte', url: '/topics/compte/gestion-compte'}, 
                  { label: 'Sécurité du compte', url: '/topics/compte/securite'}
              ]}/>
              <TopicsContainer 
                title='Sécurité et accessibilité' links={[
                  { label: 'Questions de sécurité', url: '/topics/securite/question-securite'}, 
                  { label: 'Signaler un problème', url: '/topics/securite/signal-probleme'},
              ]}/>
              <TopicsContainer 
                title="À propos de Wodzone" links={[
                  { label: 'Premiers pas', url: '/topics/about/first-step'}, 
                  { label: 'Fonctionnement de Wodzone', url: '/topics/about/fonctionnement'}, 
                  { label: 'Conditions juridiques', url: '/topics/about/juridiques'}, 
              ]}/>
            </div>
          </>
        }
        {homeOngletActif.id === 2 && 
          <div className="help-card-grid-container allTopics mt-48">
            <TopicsContainer 
              title="Gestion de votre compétition" links={[
                { label: "Général", url: '/topics/gestion-compet/general'}, 
                { label: "Volontaires et co-organisateurs", url: '/topics/gestion-compet/general'},
                { label: "Paiements et versements", url: '/topics/gestion-compet/versements'},
                { label: "Exporter les données", url: '/topics/gestion-compet/data'},
            ]}/>
            <TopicsContainer 
              title='Versements' links={[
                { label: 'Fonctionnement des versements', url: '/topics/versements/fonctionnment-versements'}, 
            ]}/>
            <TopicsContainer 
              title='Votre compte' links={[
                { label: 'Créer un compte', url: '/topics/compte/1'}, 
                { label: 'Gérer votre compte', url: '/topics/compte/gestion-compte'}, 
                { label: 'Sécurité du compte', url: '/topics/compte/securite'}
            ]}/>
            <TopicsContainer 
              title='Sécurité et accessibilité' links={[
                { label: 'Questions de sécurité', url: '/topics/securite/question-securite'}, 
                { label: 'Signaler un problème', url: '/topics/securite/signal-probleme'},
            ]}/>
            <TopicsContainer 
              title="À propos de Wodzone" links={[
                { label: 'Premiers pas', url: '/topics/about/first-step'}, 
                { label: 'Fonctionnement de Wodzone', url: '/topics/about/fonctionnement'}, 
                { label: 'Conditions juridiques', url: '/topics/about/juridiques'}, 
            ]}/>
          </div>
        }
      </div>  
    </div>
  )
}

export default HelpAllTopics